export const breakPoints = {
    smallphone: 320,
    phoneportrait: 375,
    phoneplusportrait: 414,
    tabletportrait: 700,
    tabletlandscape: 1024,
    laptop: 1366,
};
